module.exports = __webpack_public_path__ + "static/media/church2.734d5b59.jpg";